import * as React from 'react'
import cx from 'classnames'

import SectionStyles from 'components/Settings/Section.module.scss'
import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import Styles from './SuperAdmin.module.scss'

import { useSession } from 'hooks/useSession'
import { useSuperAdmin } from 'hooks/useSuperAdmin'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

export const SuperAdmin = () => {
  const { auth } = useSession()
  const { superAdminMode, enterSuperAdminMode, exitSuperAdminMode } = useSuperAdmin()

  if (!auth) return null

  /**
   * Sets or deletes auth.superAdminMode
   * - which will control what data is fetched for user or workspace throughout the application.
   */
  const toggleSuperAdminMode = () => {
    superAdminMode ? exitSuperAdminMode() : enterSuperAdminMode()
  }

  return (
    <>
      <div className={SettingsStyles.divider} />
      <div className={SectionStyles.sectionRow}>
        <div className={cx(SectionStyles.sectionFieldWrapper, SectionStyles.alignTop)}>
          <div className={SectionStyles.rowStyles}>
            <Heading level={5}>Super Admin View</Heading>
            <ToggleButton checked={superAdminMode} name="superAdminMode" handleChange={toggleSuperAdminMode} />
          </div>
          <div className={cx(SectionStyles.sectionInput, SectionStyles.editing, Styles.actionForm)}>
            <Text variant="secondary" color="var(--dark-60)">
              See every doc that exists in your workspace.
            </Text>
          </div>
        </div>
      </div>
    </>
  )
}
